<template>
  <v-container
    v-if="ready"
    class="px-4 py-6"
    style="background-color: #ffffff;"
  >
  <div class="mb-6">
    <h2>問題類別</h2>
    <v-select
      v-model="questionType"
      :items="questionTypeArr"
      item-text="text"
      item-value="idx"
      height="56"
      filled
      dense
      hide-details
      class="mb-6 mt-0"
    ></v-select>
  </div>
  <div class="mb-6">
    <template v-if="questionType === 0">
      <h2>問題類型</h2>
      <div class="option-group">
        <div
          v-for="option in options"
          :key="option.parentId"
          class="ma-0 py-2"
        >
          <input type="radio" :id="option.parentId" :value="option.parentId" v-model="selectedCategory">
          <label :for="option.parentId"><span></span>{{option.parentName}}</label>
        </div>
      </div>
    </template>
    <template v-else>
      <h2>訂單編號</h2>
      <div
        v-if="orderLists.length"
        class="select-btn"
        @click="showPanel"
      >
        <div class="selected-order" v-if="selectedOrderIdx !== null">
          <div class="orderNo">
            {{ this.orderLists[selectedOrderIdx].orderNo }}
            <img
              class="accordion-btn-arrow"
              src="@/assets/img/select_arrow_down.svg"
            />
          </div>
        </div>
        <div class="select-order" v-else>
          選擇訂單編號
          <img
            class="accordion-btn-arrow"
            src="@/assets/img/select_arrow_down.svg"
          />
        </div>
      </div>
      <div v-else class="select-btn">
        <div class="select-order">
          尚無訂單
          <img
            class="accordion-btn-arrow"
            src="@/assets/img/select_arrow_down.svg"
          />
        </div>
      </div>
      <div
        class="select-panel mt-4 px-4 py-1"
        :style="{ display: orderVisible ? 'block' : 'none' }"
      >
        <div
          v-for="(orderList, i) in orderLists"
          :key="i"
          @click="selectOrder(i)"
          class="order-select"
        >
          <div class="order-code">
            <span style="color:#9b9b9b">訂單編號：</span>
            {{ orderList.orderNo }}
          </div>
          <div class="order-code">
            <span style="color:#9b9b9b">訂單日期：</span>
            {{ orderList.createTime }}
          </div>
          <div class="order-name">{{ orderList.title }}</div>
        </div>
      </div>
      <div class="order-select-block" v-if="selectedOrderIdx !== null">
        <div
          class="order-item"
          v-for="(product, i) in orderLists[selectedOrderIdx].products"
          :key="i"
        >
          <div class="order-content">
            <div class="order-item-photo">
              <img
                onerror="this.style.display = 'none';"
                :src="product.imageUrl"
              />
            </div>
            <div class="order-item-content ml-4">
              <div class="item-name">{{ product.productName }}</div>
              <p>${{ product.totalPrice }} 
                <span>x {{ product.orderQuantity }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
  <div class="mb-6">
    <h2>問題描述</h2>
    <div class="text-area">
      <v-textarea
        filled
        placeholder="請說明您的問題，若有照片也請協助提供"
        v-model="textArea"
        hide-details
      ></v-textarea>
      <div class="image-upload img-box">
        <UploadImg
          ref="uploadImg"
          @loading="value => { imgLoading = value }"
          @hasImg="test"
        />
        <p class="" v-show="!isImgOnloaded">上傳圖片</p>
        <div class="input-tip py-1">{{ imgAlert }}</div>
      </div>
    </div>
  </div>
    <!-- <div class="input-block">
      <div class="text-area">
        <AutoResizeField>
          <textarea
            v-model="textArea"
            type="text"
            maxlength="1000"
            rows="1"
            placeholder="請說明您的問題"
            hide-details
            dense
          />
        </AutoResizeField>
      </div>
      <div class="input-tip py-1">
        請您詳述問題說明，若是有照片也請協助提供
        <span
          class="text-area-empty"
          :class="{ 'text-area-empty-show': textAreaEmpty }"
        >
          必填欄位
        </span>
      </div>
    </div> -->
    <!-- <div class="image-upload my-4">
      <p class="mb-2">上傳圖片</p>
      <UploadImg
        ref="uploadImg"
        @loading="value => { imgLoading = value }"
      />
      <div class="input-tip py-1">{{ imgAlert }}</div>
    </div> -->
    <div class="btn-area">
      <v-btn
        color="primary"
        height="48"
        block
        :disabled="!canSend && !imgLoading"
        @click="askingQuestion()"
        depressed
      >
        確認送出
      </v-btn>
      
    </div>
    <waiting-overlay v-model="submitting"></waiting-overlay>
  </v-container>
  <Spinner v-else bgc="#f6f6f6" />
</template>

<script>
// 選擇訂單的 Placeholeder 預設內容
const defaultPlaceholderOne = `訂單編號<img class="accordion-btn-arrow mr-2" src="${require('@/assets/img/triangle-down.svg')}"/>`

import AutoResizeField from '@/components/shared/AutoResizeField'
import UploadImg from '@/components/shared/UploadImg'
import WaitingOverlay from '@/components/shared/WaitingOverlay'
import Spinner from '@/components/shared/Spinner.vue'
export default {
  name: 'contactCustomerService',
  components: {
    AutoResizeField,
    UploadImg,
    WaitingOverlay,
    Spinner,
  },
  data: function() {
    return {
      options: [],
      orderLists: [],
      placeholder: ['請選擇問題類別', defaultPlaceholderOne],
      selectedCategory: null,
      selectedOrderIdx: null,
      selectedOrder: null,
      panelVisible: false,
      orderVisible: false,
      textArea: '',
      questionType: 0,
      submitting: false,
      imgAlert: '',
      textAreaEmpty: false,
      selectorEmpty: false,
      imgLoading: false,
      ready: false,
      termsFromApi: '',
      questionTypeArr: [
        { text: '一般問題', idx: 0 },
        { text: '訂單問題', idx: 1 },
      ],
      isImgOnloaded: false,
    }
  },
  methods: {
    test (hasImg) {
      this.isImgOnloaded = hasImg
    },
    goPrev() {
      if (
        this.$route.params.orderNo != undefined &&
        this.$route.params.orderNo != '' &&
        this.$route.params.orderNo != '0'
      ) {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: 'customerServicePage',
          params: { type: this.$route.params.questionType },
        })
      }
    },
    selectType(index) {
      if (this.questionType === 0) {
        this.placeholder[0] = this.options[index].parentName
        this.selectedCategory = this.options[index].parentId
        this.panelVisible = false
      }
    },
    selectOrder(index) {
      if (this.questionType === 1) {
        this.selectedOrderIdx = index
        this.selectedOrder = this.orderLists[index].orderNo
        this.orderVisible = false
      }
    },
    showPanel() {
      this.questionType === 0
        ? (this.panelVisible = !this.panelVisible)
        : (this.orderVisible = !this.orderVisible)
    },
    cancleSelectOrder() {
      this.selectedOrderIdx = null
      this.selectedOrder = null
    },
    questionImg(type) {
      const img = type ? 'order-question' : 'question'
      if (this.questionType === type) {
        return require(`../../assets/img/${img}-red.svg`)
      }
      return require(`../../assets/img/${img}.svg`)
    },
    askingQuestion() {
      const self = this
      this.imgAlert = ''
      // 必選問題 or 必選訂單
      if (
        (this.questionType === 0 && !this.selectedCategory) ||
        (this.questionType === 1 && !this.selectedOrder)
      ) {
        this.selectorEmpty = true
      } else {
        this.selectorEmpty = false
      }
      // 必輸入問題
      if (!this.textArea || this.textArea === '') {
        this.textAreaEmpty = true
      } else {
        this.textAreaEmpty = false
      }
      if (!this.textAreaEmpty && !this.selectorEmpty) {
        self.submitting = true
      } else {
        return
      }
      // 如果客戶有傳圖片就傳圖片的 base64String，不然就傳個空字串（非必填）
      const uploadImg = this.$refs.uploadImg.imgPreview[0]
      const base64 = uploadImg ? uploadImg.data : ''
      if (typeof uploadImg != 'undefined') {
        const imgType = base64.toString().split(';')[0]
        if (imgType.toLowerCase().indexOf('image') <= 0) {
          this.imgAlert = '請勿上傳非圖片檔'
          this.submitting = false
          return false
        }
        if (imgType.toLowerCase() == 'data:image/gif') {
          this.imgAlert = '請勿上傳gif檔'
          this.submitting = false
          return false
        }
      }
      if (this.questionType === 1) {
        // 30 建立客服案件（訂單問題）
        api
          .createOrderIssue(0, this.textArea, base64, this.selectedOrder)
          .then(res => {
            this.submitting = false
            if (res.code === 1000) {
              this.redirectToCS(res.data)
            } else {
              this.$bus.$emit('callAllert', {
                messageContent: '訊息傳送失敗(錯誤代碼:' + res.code + ')',
              })
            }
          })
          .catch(err => {
            self.submitting = false
            this.$bus.$emit('callAllert', {
              messageContent: '訊息傳送失敗(錯誤代碼:' + err.code + ')',
            })
          })
      } else if (this.questionType === 0) {
        // 29 建立客服案件（一般問題）
        // 每一筆一般問題都會是一個新的問題（by PM）
        api
          .createIssue(
            this.selectedCategory,
            this.textArea,
            base64,
            this.serviceNo
          )
          .then(res => {
            this.submitting = false
            if (res.code === 1000) {
              this.redirectToCS(res.data)
            } else {
              this.$bus.$emit('callAllert', {
                messageContent: '訊息傳送失敗(錯誤代碼:' + res.code + ')',
              })
            }
          })
          .catch(err => {
            this.submitting = false
            this.$bus.$emit('callAllert', {
              messageContent: '訊息傳送失敗(錯誤代碼:' + err.code + ')',
            })
          })
      }
    },
    redirectToCS(serviceNo) {
      window.history.pushState(null, null, '/customerService/1')
      this.$router.push({
        name: 'serviceAskingPage',
        params: { type: 1, serviceNo: serviceNo, newAsk: 1 },
      })
    },
  },
  computed: {
    placeholderStyle: function() {
      if (this.questionType === 0 && this.selectedCategory !== null) {
        return { color: '#222222', display: 'flex', flexFlow: 'wrap' }
      }
      if (this.questionType === 1 && this.selectedOrderIdx !== null) {
        return { color: '#222222', flexFlow: 'column' }
      }
      return {
        color: '#9b9b9b',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }
    },
    canSend() {
      if (this.questionType === 0){
        return this.selectedCategory && this.textArea !== '' ? true : false
      }else if(this.questionType === 1){
        return this.selectedOrder && this.textArea !== '' ? true : false 
      }
    },
  },
  created() {
    this.termsFromApi = JSON.parse(
      window.localStorage.getItem('initial_config')
    ).terms.customerService.contact
    // 31 取得案件分類
    api.getCustomerServiceCategories().then(res => {
      return (this.options = res.data)
    })

    // 36 取得訂單列表(客服)
    api
      .getCustomerServiceOrderList()
      .then(res => {
        return (this.orderLists = res.data)
      })
      .then(data => {
        if (
          this.$route.params &&
          this.$route.params.questionType === 1 &&
          this.$route.params.orderNo
        ) {
          this.questionType = this.$route.params.questionType
          const lists = JSON.parse(JSON.stringify(data))
          const orderNo = this.$route.params.orderNo
          lists.forEach((list, i) => {
            if (list.orderNo === orderNo) {
              this.selectOrder(i)
              this.ready = true
            } else {
              this.ready = true
            }
          })
          if (!this.orderLists.length) {
            this.ready = true
          }
        } else {
          this.ready = true
        }
      })
      .catch(err => {
        this.$bus.$emit('callAllert', {
          messageContent: '出了一些狀況(' + err.code || '0000' + ')',
          callback: () => {
            if (localStorage.getItem('source') === 'e7g') {
              window.location = process.env.VUE_APP_E7G_HOME
            } else {
              this.$router.replace({ name: 'home' })
            }
          },
        })
      })
  },
  watch: {
    questionType: function(newVal, oldVal) {
      if (newVal !== oldVal && this.ready) {
        this.textArea = ''
        this.orderVisible = false
        this.panelVisible = false
        this.textAreaEmpty = false
        this.selectorEmpty = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-area-empty,
.selector-empty {
  color: #1da7fc;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.text-area-empty {
  margin-left: 8px;
}

.selector-empty {
  font-size: 12px;
}

.text-area-empty-show,
.selector-empty-show {
  opacity: 1;
}

.question-button img,
.image-upload-btn > img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.question-button {
  padding: 24px 0px 16px;
  font-size: 14px;
  color: #4a4a4a;
  display: flex;
}

.question-button > div {
  flex: 1 1 auto;
}

.question-button_active {
  color: #1da7fc !important;
  border-color: #1da7fc !important;
}

.question-button > div {
  width: 168px;
  height: 68px;
  border-radius: 5px;
  border: solid 1px #ededed;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.select-block {
  padding: 18px 0px 6px;
  position: relative;
}

.item-layout {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: column;
}

.select-btn {
  box-shadow: inset 0 -1px 0 0 #ededed;
  padding: 6px 0px;

  > p {
    margin: 0;
    flex: 1 1 auto;
  }

  > img {
    margin-left: auto;
    flex: 0 0 auto;
  }
  .select-title {
    font-size: 13px;
  }
}

.textAreaCount {
  margin: 0;
  font-size: 13px;
  color: #9b9b9b;
  text-align: right;
}

.select-panel {
  position: absolute;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  left: 16px;
  right: 16px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar-thumb {
    border-left: 10px solid white;
    border-right: 2px solid white;
    background-color: #ededed;
  }
}

.select-panel > div {
  padding: 13px 0px;
  border-bottom: solid 1px #ededed;
  color: #4b4b4b;
}

.selected-order {
  font-size: 13px;
  .select-title {
    color: #9b9b9b;
  }
  .orderNo {
    margin-top: 10px;
    color: #4a4a4a;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .product-name {
    margin-top: 4px;
    font-size: 16px;
    color: #222;
  }
}

.select-order {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.input-tip {
  font-size: 12px;
  color: #6d7278;
}

.image-upload > p,
.order-select-block > p {
  font-size: 13px;
  color: #9b9b9b;
}

.prompt-text {
  font-size: 14px;
  line-height: 24px;
  color: #545454;
}

.buttons {
  display: flex;
  padding: 60px 0px 24px;
}

.buttons > button {
  flex: 1;
}

.order-select {
  border-bottom: solid 1px #ededed;
  margin-top: 6px;
}

.order-code > img {
  width: 11px;
  height: 9px;
  object-fit: contain;
}

.order-code {
  font-size: 13px;
  color: #4a4a4a;
}

.order-name {
  font-size: 16px;
  line-height: 24px;
  color: #222222;
  margin: 4px 0px 6px;
}

.order-item {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  margin-top: 20px;
  padding: 12px 4px 16px 8px;
}

.order-content {
  display: flex;
}

.top-section {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #4a4a4a;
  margin-bottom: 8px;
  .icon {
    display: inline-block;
    font-size: 0;
    width: 16px;
    vertical-align: text-bottom;
    margin-right: 5px;
    img {
      width: 100%;
    }
  }
  .cancel-btn {
    font-size: 0;
    width: 16px;
    height: 16px;
    img {
      width: 100%;
    }
  }
}
.order-item-photo {
  width: 29%;
  height: 0;
  padding-bottom: 29%;
  border-radius: 10px;
  overflow: hidden;
  align-self: center;
  flex-shrink: 0;
  background: url('../../assets/img/placholder_512.svg');
  background-size: contain;
  background-repeat: no-repeat;
  img {
    width: 100%;
  }
}

.order-item-content {
  max-width: 100%;
}

.order-item-content > div.item-name {
  width: 70%;
  font-size: 16px;
  font-weight: bold;
  color: #222222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-item-content > div.item-amount {
  font-size: 12px;
  color: #9b9b9b;
  margin: 5px 0;
}

.order-item-content > div.item-price {
  font-size: 12px;
  color: #545454;
}

.input-block {
  padding-top: 18px;
}

h2 {
  font-size: 16px;
  font-weight: 600;
  color: #2a2b2b;
  margin-bottom: 16px;
}

>>> .v-input {
  padding-top: 0;
}

>>> .v-input__slot {
  border-radius: 16px;
  background: #f3f5f8 !important;
  padding: 0 16px !important;
  .v-input__icon {
    display: none;
  }
  &:before, &:after {
    display: none;
  } 
  .v-select__slot {
    position: relative;
    &::after {
      content: '';
      width: 18px;
      height: 18px;
      background-image: url('~@/assets/img/select_arrow_down.svg');
    }
  }
}


.option-group {
  position: relative;
  margin-right: 12px;
  input[type="radio"] {
    display:none;
  }
  input[type="radio"] label {
    color: #2a2b2b;
    font-size: 16px;
  }
  input[type="radio"] + label span {
    content: '';
    background-color: #f3f5f8;
    display: inline-block;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 16px;
  }
  input[type="radio"]:checked + label span {
    background-color: #1da7fc;
    background-image: url('~@/assets/img/radio-ticked.svg');
  }
}

>>>.v-textarea .v-input__slot {
  padding: 4px 16px !important;
}

.text-area {
  position: relative;
  >>> textarea {
    min-height: 168px;
  }
  .img-box {
    position: absolute;
    bottom: 16px;
    left: 16px;
    display: flex;
    align-items: center;
    background-color: #f3f5f8;
    p {
      white-space: nowrap;
      font-size: 14px;
      color: #8e9091;
      margin-left: 8px;
    }
  }
}

.btn-area {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px 16px;
  >>> .v-btn__content {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.4px;
  }
  >>> .v-btn--disabled.v-btn--has-bg {
    background-color: #c0c2c4 !important;
    .v-btn__content {
      color: #fff;
    }
  }
}

.select-btn {
  padding: 16px;
  background-color: #f3f5f8;
  border-radius: 16px;
  box-shadow: none;
  color: #2a2b2b;
  .accordion-btn-arrow {
    width: 18px;
    height: 18px;
  }
  .select-order, .orderNo {
    font-size: 16px;
    margin: 0;
    color: #2a2b2b;
    align-items: center;
  }
}

.order-select-block {
  box-shadow: none;
  background: #fff;
  margin-top: 16px;
  .order-item {
    box-shadow: none;
    border-radius: 16px;
    border: 1px solid #c0c2c4;
    padding: 16px;
  }
  .order-item-content{
    overflow: hidden;
    .item-name {
      width: auto;
      font-size: 14px;
      font-weight: 500;
      color: #2a2b2b;
      margin-bottom: 8px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      color: #2a2b2b;
      margin-right: 5px;
      span {
        font-weight: normal;
      }
    }
  }
  .order-item-photo {
    width: 15.5%;
    padding-bottom: 15.5%;
    border-radius: 8px;
    align-self: auto;
    img {
      border-radius: 8px;
    }
  }
}

</style>
